import styled from 'styled-components';

const QUESTIONS_BUTTON_COLOR = {
  0: '#65489C',
  1: '#3B91CF',
  2: '#EF4D3E',
  3: '#F19626FF',
};

const Question_Answer = {
  0: '#3B91CF', // for question
  1: '#44BA8E', // for answer
  2: '#65489C', // for question button
  3: '#EF4D3E', // for rejected answer
};

const Container = styled.div`
  direction: ${(props) => props.theme.direction} !important;
  min-height: 2.5rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.5rem !important;
  color: ${(props) =>
    props.type === 'defaultQuestion'
      ? QUESTIONS_BUTTON_COLOR[props.id]
      : Question_Answer[props.id]} !important;
  background: ${(props) =>
    props.type === 'defaultQuestion'
      ? `linear-gradient(to ${props.theme.direction === 'rtl' ? 'right' : 'left'}, ${QUESTIONS_BUTTON_COLOR[props.id]}, white 90%) !important`
      : `linear-gradient(to ${props.id === 0 ? (props.theme.direction === 'rtl' ? 'right' : 'left') : props.theme.direction === 'rtl' ? 'left' : 'right'}, ${Question_Answer[props.id]}, white 90%) !important`};
  transition: background 1s ease !important;

  ${(props) =>
    props.type === 'defaultQuestion' &&
    `background: ${QUESTIONS_BUTTON_COLOR[props.id]}; box-shadow: 0 0.5rem 1rem #eee !important`}
  &:hover {
    ${(props) =>
      props.type === 'defaultQuestion' &&
      `background: ${QUESTIONS_BUTTON_COLOR[props.id]}; box-shadow: 0 0.5rem 1rem #eee !important`}
  }
`;

export const Content = styled.div`
  padding: 0.7rem 0.5rem !important;
  margin: 0.1rem !important;
  background: var(--exact-white) !important;
  border-radius: 0.4rem !important;
  font-size: 1.25rem;
  line-height: 1.75rem;
  & > p {
    margin: 0;
  }
  @media only screen and (max-width: 800px) {
    margin: 0.1rem !important;
  }
`;

interface IProps {
  children: React.ReactNode;
  type?: string;
  id?: number;
}

const Box: React.FC<IProps> = ({ children, type, id = 0 }) => {
  return (
    <Container id={id} type={type}>
      <Content>{children}</Content>
    </Container>
  );
};

export default Box;
